import SystemUserTable from "./components/SystemUserTable";

const SystemUser = () =>{
    return (
        <SystemUserTable />
    )
}
export default SystemUser;